var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.1402 1 1 4.1402 1 8C1 11.8598 4.1402 15 8 15C11.8598 15 15 11.8598 15 8C15 4.1402 11.8598 1 8 1ZM8 13.6C4.9123 13.6 2.4 11.0877 2.4 8C2.4 4.9123 4.9123 2.4 8 2.4C11.0877 2.4 13.6 4.9123 13.6 8C13.6 11.0877 11.0877 13.6 8 13.6Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6996 4.8498C8.6996 4.38047 8.31913 4 7.8498 4C7.38047 4 7 4.38047 7 4.8498V8.35259L9.23087 10.4631C9.54926 10.7643 10.0475 10.7643 10.3659 10.4631C10.7103 10.1373 10.7103 9.58912 10.3659 9.26333L8.6996 7.68692V4.8498Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e5a9cb34f44107b6b8577610d29b9bd0.svg";
export { ForwardRef as ReactComponent };